import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  appointmentsByDateList: [],
  appointmentCount: 0,
};

export const DispatchSlice = createSlice({
  name: "dispatch",
  initialState,
  reducers: {
    setAppointmentsByDateList: (state, action) => {
      state.appointmentsByDateList = action.payload;
    },
    setAppointmentCount: (state, action) => {
      state.appointmentCount = action.payload;
    },
  },
});

export const { setAppointmentsByDateList, setAppointmentCount } =
  DispatchSlice.actions;

export default DispatchSlice.reducer;
